/**
 * @description Centralized query keys for facturas globales module
 * @author Omar Sánchez Martínez
 * @since 07/10/2025
 */

import type { FacturaGlobalUIFilters } from '../types';

/**
 * Query keys factory for facturas globales
 * Follows TanStack Query best practices for hierarchical key structure
 */
export const facturasGlobalesKeys = {
  /**
   * Base key for all facturas globales queries
   */
  all: () => ['facturas-globales'] as const,

  /**
   * List queries with filters
   */
  lists: () => [...facturasGlobalesKeys.all(), 'list'] as const,
  list: (filters: FacturaGlobalUIFilters) => [...facturasGlobalesKeys.lists(), filters] as const,

  /**
   * Years queries for year selector
   */
  years: () => [...facturasGlobalesKeys.all(), 'years'] as const,

  /**
   * Detail queries for individual factura global
   */
  details: () => [...facturasGlobalesKeys.all(), 'detail'] as const,
  detail: (id: number) => [...facturasGlobalesKeys.details(), id] as const,
} as const;
